import React from 'react';
import { TableHead, TableRow, TableCell, styled, Checkbox } from '@mui/material';
import { TableColumnHeader } from './TableColumnHeader';

const HeaderTableCell = styled(TableCell)(({ theme }) => ({
  fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  fontWeight: 700,
  fontSize: '0.65rem',
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  padding: '6px 10px',
  color: '#ffffff',
  borderBottom: '2px solid #033263',
  position: 'sticky',
  top: 0,
  zIndex: 30,
  whiteSpace: 'nowrap',
  backgroundColor: '#0655A5',
  backgroundImage: 'linear-gradient(180deg, #075ea6 0%, #044384 100%)',
  boxShadow: 'none',
  userSelect: 'none',
  lineHeight: 1.4,
}));

const getStickyStyles = (meta, isFirst = false) => {
  if (!meta) return {};
  return {
    position: 'sticky',
    left: meta.left,
    zIndex: meta.zIndex + 20,
    minWidth: meta.width,
    width: meta.width,
    maxWidth: meta.width,
    backgroundColor: '#0655A5',
    backgroundImage: 'linear-gradient(180deg, #075ea6 0%, #044384 100%)',
    boxShadow: meta.isLastSticky ? '2px 0 6px -2px rgba(0,0,0,0.18)' : 'none',
    borderRight: '1px solid rgba(255,255,255,0.08)',
    borderTopLeftRadius: isFirst ? '8px' : 0,
  };
};

export const TableHeader = ({
  orderedKeys,
  stickyLeftMeta,
  sortConfig,
  onSort,
  enableSorting,
  enableFiltering,
  columnFilters,
  onColumnFilterChange,
  labels,
  renderActionsCol,
  hasPartidas,
  selectable,
  numSelected,
  rowCount,
  onSelectAll,
  actionsColumnWidth
}) => {
  const isFirstCol = (key, idx) => {
    if (selectable) return false;
    if (hasPartidas) return false;
    return idx === 0;
  };

  const isLastCol = (idx) => {
    if (renderActionsCol) return false;
    return idx === orderedKeys.length - 1;
  };

  return (
    <TableHead>
      <TableRow>
        {selectable && (
          <HeaderTableCell
            sx={{
              ...(stickyLeftMeta && stickyLeftMeta['__select__'] ? getStickyStyles(stickyLeftMeta['__select__'], true) : { borderTopLeftRadius: '20px' }),
              width: 38, minWidth: 38, maxWidth: 38,
              p: '0 !important', textAlign: 'center'
            }}
          >
            <Checkbox 
              size="small"
              indeterminate={numSelected > 0 && numSelected < rowCount}
              checked={rowCount > 0 && numSelected === rowCount}
              onChange={onSelectAll}
              sx={{ color: 'rgba(255,255,255,0.5)', '&.Mui-checked, &.MuiCheckbox-indeterminate': { color: '#ffffff' } }}
            />
          </HeaderTableCell>
        )}
        {hasPartidas && (
          <HeaderTableCell
            sx={{
              ...(stickyLeftMeta && stickyLeftMeta['__expand__'] ? getStickyStyles(stickyLeftMeta['__expand__'], !selectable) : { borderTopLeftRadius: !selectable ? '20px' : 0 }),
              width: 36, minWidth: 36, maxWidth: 36,
              p: '0 !important'
            }}
          />
        )}
        {orderedKeys.map((key, idx) => {
          const first = isFirstCol(key, idx);
          const last = isLastCol(idx);
          const isPrimaryCol = key === 'PERFIL' || key === 'NOMBRE_DEPARTAMENTO' || key === 'CENTRO_COSTO' || key === 'DESCRIPCION' || (orderedKeys.length <= 4 && (key !== 'ID' && key !== 'ACTIVO'));

          return (
            <TableColumnHeader
              key={key}
              columnKey={key}
              label={labels[key] || key}
              isStickyMeta={stickyLeftMeta && stickyLeftMeta[key]}
              sortConfig={sortConfig}
              onSort={onSort}
              enableSorting={enableSorting}
              enableFiltering={enableFiltering}
              filterValue={columnFilters ? columnFilters[key] : ''}
              onFilterChange={onColumnFilterChange}
              isFirst={first}
              isLast={last}
              isPrimaryCol={isPrimaryCol}
            />
          );
        })}
        {renderActionsCol && (
          <HeaderTableCell sx={{ 
            textAlign: 'center',
            position: 'sticky', 
            right: 0, 
            zIndex: 31,
            boxShadow: 'none',
            borderTopRightRadius: '8px',
            py: 0.7,
            px: actionsColumnWidth ? 0.5 : 1,
            width: actionsColumnWidth,
            minWidth: actionsColumnWidth,
            maxWidth: actionsColumnWidth,
            backgroundColor: '#0655A5',
            backgroundImage: 'linear-gradient(180deg, #075ea6 0%, #044384 100%)',
            color: '#ffffff',
          }}>
            {actionsColumnWidth && actionsColumnWidth < 60 ? 'Acc.' : 'ACCIONES'}
          </HeaderTableCell>
        )}
      </TableRow>
    </TableHead>
  );
};
